import type { ReactNode } from 'react'
import type { DropdownMenuItemProps, DropdownMenuSeparatorProps } from '@radix-ui/react-dropdown-menu'

export type RadixDropdownItemProps = DropdownMenuItemProps & {
  type: 'item'
  component: ReactNode
}

export type RadixDropdownSeparatorProps = DropdownMenuSeparatorProps & {
  type: 'separator'
}

export const DropdownItemColor = {
  primary: 'primary',
  danger: 'danger'
} as const

export type DropdownItemColor = (typeof DropdownItemColor)[keyof typeof DropdownItemColor]

export const DropdownItemSize = {
  small: 'small',
  medium: 'medium'
} as const

export type DropdownItemSize = (typeof DropdownItemSize)[keyof typeof DropdownItemSize]

export type DropdownItemsProps = RadixDropdownItemProps | RadixDropdownSeparatorProps
